<template>
	<Container>
		<TopBar />
		<div class='paymentPage' >
			<div class="top">
				<div class="logo">
					<div class="shadow">
						<img src="@/assets/order/success.png">
					</div>
				</div>
				<h2>支付完成</h2>
			</div>
			<div class="mid">
				<div class="orderNo">
					<b>NO:&nbsp;{{desc.OrderNo}}</b>
					<span>已付款</span>
				</div>
				<div class="total">
					合计：¥{{desc.TotalPaid.toFixed(2)}}&nbsp;
				</div>
			</div>
			
			<div class="foot">
				<Button size='large' type="primary" shape="circle" @click="goOrderList">我的订单</Button>
			</div>
		</div>
	</Container>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import { api_methods } from "@/service/loadData";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { cvoUrl,baseUrl } from "@/config/env";
import {
	systemConfigMethods,
	
} from "@/components/common/mixin";
import util from "@/config/util";
import {cleanUserCache} from '@/service/cache'
export default {
	data() {
		return {
			desc:{
				TotalPaid:''
			}
		};
	},
	created() {
		this.$nextTick(function () {
			this.initData(this.$route.query.orderno);
		});
	},
	mounted() {},
	watch: {},
	mixins: [systemConfigMethods],
	components: {
		TopBar,
	},
	computed: {
		...mapGetters([]),
		...mapState({
		}),
	},
	methods: {
		...mapActions([
			'getMergePayOrderAction'
		]),
		...mapMutations([
			"CHOOSE_ADDRESS",
		]),
		async initData(orderNo, os) {
			let response = await this.getMergePayOrderAction(orderNo)
			this.desc = response.OrderInfo[0]
		},
		goOrderList() {
			this.$router.push({
				path: "/order/orders",
			});
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.load {
	width: 100%;
	//margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
	height: 350px;
	position: relative;
}
.paymentPage {
	width: 70.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.top {
	text-align: center;
	margin: auto;
	margin-top: 30px;
	.logo {
		margin: auto;
		width: 150px;
		border-radius: 200px;
		box-shadow: 1px 1px 20px #dddddd8c;
		height: 150px;
		text-align: center;
		line-height: 210px;
		background: $green;
		img {
			width: 55px;
		}
	}
	h2 {
		color: $green;
		margin-top: 20px;
	}
	.time {
		margin-top: 20px;
		span {
			padding: 5px;
			background-color: $theme-color;
			display: inline-block;
			color: white;
		}
		i {
			font-style: normal;
			@include fontSize($font-size-13);
			margin: 0 5px;
		}
		b {
			font-weight: 500;
			margin-right: 5px;
		}
	}
	p {
		margin-top: 20px;
	}
}
.showlrp-hint {
	width: 41.53vw;
	margin: auto;
	margin-top: 20px;
	p {
		@include fontSize($font-size-16);
		padding: 5px;
		color: $theme-color;
	}
	button {
		background-color: #bc86c8;
		color: white;
		margin: 10px 0;
	}
	.intro {
		background-color: white;
		margin-top: 0.5px;
		//padding:2px 0.55px;
		padding-top: 0.5px;
		@include fontSize($font-size-16);
		h3 {
			@include fontSize($font-size-16);
		}
		p {
			margin-top: 0.1px;
			@include fontSize($font-size-16);
			color: black;
		}
	}
}
.mid {
	width: 40.03vw;
	margin: auto;
	margin-top: 20px;
	.orderNo {
		border-bottom: 1px solid #dedede;
		height: 30px;
		b {
			float: left;
		}
		span {
			float: right;
			padding: 1px 10px;
			border: 1px solid $theme-color;
			color: $theme-color;
			@include fontSize($font-size-13);
			border-radius: 10px;
		}
	}
	.info {
		border-bottom: 1px solid #dedede;
		.item {
			height: 30px;
			line-height: 30px;
			overflow: hidden;
			span:nth-of-type(2) {
				color: $theme-color;
				float: right;
			}
		}
		&.address {
			span:nth-of-type(2) {
				color: #636363;
				float: right;
			}
			span.update {
				b {
					color: $theme-color;
					font-weight: 800;
					cursor: pointer;
				}
			}
		}
	}
	.total {
		margin-top: 10px;
		font-weight: 500;
	}
	.payList {
		.item {
			cursor: pointer;
			padding: 10px 0;
			border-bottom: 1px solid #dedede;
			img:nth-of-type(1) {
				width: 50px;
			}
			img:nth-of-type(2) {
				float: right;
				width: 25px;
				margin-top: 10px;
			}
		}
	}
}
.foot {
	margin-top: 30px;
	text-align: center;
	button {
		width: 150px;
		margin-right: 10px;
	}
}
.newPc {
	color: $theme-color;
	// font-weight: 800;
	//color: red;
	@include fontSize($font-size-17);
}
.unfinished {
	color: $theme-color;
	@include fontSize($font-size-17);
	margin-top: 20px;
	.btn {
		color:$dark-theme-color;
		text-decoration: underline;
		cursor: pointer;
		font-weight: bold;
	}
}
.newCustomer{
	width: 100%;
	height: 100%;
	position: fixed;
	background-color: #63636373;
	left: 0;
	top: 0;
	z-index: 10000;
	text-align: center;
	&>div{
		width: 3rem;
		cursor: pointer;
		height: 1.5rem;
		position:absolute;
		top: 5.5rem;
		left: 6.8rem;
	}
	img{
		height: 7.0rem
	}
	i{
		font-size: 0.6rem;
		cursor: pointer;
		position: absolute;
		bottom:0.2rem;
		left: 47%;
	}

}
.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s;
}
.fade-enter,
.fade-leave-active {
	opacity: 0;
}



@media (max-width: 768px) {
	.paymentPage {
		width: 90%;
		font-size: 0.5rem;
	}
	.mid {
		width: 100%;
	}
}
</style>